/* Lunelle - vignette animee du porte-monnaie offert.
   Fait defiler les coloris en fondu enchaine dans la vignette du cadeau.

   POURQUOI. Avec un seul coloris affiche, la cliente peut croire qu'aucun ne
   s'accorde au sac qu'elle s'apprete a choisir, ce qui devalue le cadeau.
   Ce n'est PAS un GIF : on enchaine les vraies photos produit deja referencees
   par les pastilles (data-img). Rien a fabriquer ni a heberger, ca suit le
   catalogue tout seul, c'est bien plus leger, et un GIF (256 couleurs) baverait
   sur des photos.

   QUAND. Etat 'locked' UNIQUEMENT. Des que la cliente peut choisir ('unlocked')
   la vignette suit la pastille selectionnee ; une fois le cadeau pris
   ('claimed') elle montre le coloris obtenu. L'animation vend la gamme, le
   selecteur gere le choix : elle ne contredit jamais un choix en cours.

   ORDRE. Best-sellers d'abord (data-gift-priority : Noir Integral, Marron,
   Beige Uni, Leopard Noir), puis les autres dans l'ordre du catalogue. On
   parcourt TOUTES les pastilles, meme celles masquees par le filtre "assorti au
   sac" : en 'locked' le selecteur n'est pas affiche, donc rien n'est contredit,
   et le but est justement de montrer la gamme.

   RYTHME : 1.8 s d'affichage + 0.6 s de fondu = 2.4 s par coloris.

   COUT MAITRISE (le tiroir a deja eu des soucis de fluidite) :
     - un seul minuteur partage pour toutes les instances
     - pause si l'onglet est masque, ou si la vignette n'est pas visible
     - rien du tout si prefers-reduced-motion
     - l'image suivante est prechargee avant le fondu, sinon on saute son tour
   Aucun changement de mise en page : le calque de fondu est en position:absolute
   dans la vignette existante. */
(function () {
  if (window.__lunelleGiftThumb) return;
  window.__lunelleGiftThumb = true;

  var HOLD = 1800;
  var FADE = 600;
  var timer = null;
  var state = {};   /* index courant par instance, cle = position dans le DOM */

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function visible(el) {
    if (!el || !el.getClientRects().length) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < (window.innerHeight || 0);
  }

  /* Ordre de defilement : priorites d'abord, puis le reste. */
  function order(root) {
    var all = [].slice.call(root.querySelectorAll('[data-gift-swatch]'));
    var imgs = all.map(function (s) {
      return { color: s.getAttribute('data-color') || '', img: s.getAttribute('data-img') || '' };
    }).filter(function (o) { return o.img; });

    var pref = (root.getAttribute('data-gift-priority') || '').split(',')
      .map(function (s) { return s.trim(); }).filter(Boolean);

    var head = [];
    pref.forEach(function (name) {
      var hit = imgs.filter(function (o) { return o.color === name; })[0];
      if (hit && head.indexOf(hit) === -1) head.push(hit);
    });
    var tail = imgs.filter(function (o) { return head.indexOf(o) === -1; });
    return head.concat(tail);
  }

  function preload(url) {
    return new Promise(function (resolve) {
      var im = new Image();
      im.onload = function () { resolve(true); };
      im.onerror = function () { resolve(false); };
      im.src = url;
    });
  }

  function step(root, key) {
    var thumb = root.querySelector('[data-gift-thumb]');
    var fade = root.querySelector('[data-gift-thumb-fade]');
    if (!thumb || !fade) return;

    var list = order(root);
    if (list.length < 2) return;

    var i = (state[key] == null ? 0 : state[key]);
    i = (i + 1) % list.length;
    state[key] = i;
    var url = list[i].img;

    preload(url).then(function (ok) {
      if (!ok) return;
      /* L'etat a pu changer pendant le prechargement. */
      if (root.getAttribute('data-state') !== 'locked') return;
      fade.style.backgroundImage = "url('" + url + "')";
      requestAnimationFrame(function () { fade.classList.add('is-on'); });
      setTimeout(function () {
        thumb.style.backgroundImage = "url('" + url + "')";
        /* On repasse le calque a 0 SANS transition, sinon il refond en sens
           inverse et l'image clignote. */
        fade.style.transition = 'none';
        fade.classList.remove('is-on');
        void fade.offsetWidth;
        fade.style.transition = '';
      }, FADE + 40);
    });
  }

  function tick() {
    if (document.hidden) return;
    document.querySelectorAll('[data-lunelle-gift]').forEach(function (root, idx) {
      if (root.getAttribute('data-state') !== 'locked') return;
      if (!visible(root.querySelector('[data-gift-thumb]'))) return;
      step(root, idx);
    });
  }

  function start() {
    if (timer || reduced()) return;
    timer = setInterval(tick, HOLD + FADE);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
